<template>
  <div>
    <div
      v-if="customers.length === 0"
      class="text-center py-4 grey--text"
    >
      最近来店した顧客はいません
    </div>

    <v-chip-group
      v-else
      column
      class="customer-chip-group"
    >
      <v-chip
        v-for="customer in customers"
        :key="customer.id"
        outlined
        @click="handleCustomerClick(customer)"
      >
        <v-avatar
          left
          color="primary"
          class="white--text"
        >
          {{ getInitial(customer.name) }}
        </v-avatar>
        {{ customer.name }}
        <span
          v-if="customer.memberNumber"
          class="ml-1 grey--text text--darken-1"
        >
          ({{ customer.memberNumber }})
        </span>
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import { mdiAccountClock } from '@mdi/js'

export default {
  name: 'CustomerRecentVisits',
  props: {
    customers: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const getInitial = name => {
      if (!name) return '?'

      return name.charAt(0)
    }

    const handleCustomerClick = customer => {
      emit('click', customer)
    }

    return {
      getInitial,
      handleCustomerClick,
      icons: {
        mdiAccountClock,
      },
    }
  },
}
</script>

<style scoped>
.customer-chip-group {
  max-height: 264px;
  overflow-y: auto;
}
</style>
